module.exports = __webpack_public_path__ + "img/tracker.3e417c41.svg";